<template>
  <div>
    <RangePicker
        popupClassName="smart_popupClassName"
        :presets="rangePresets"
        :placeholder="['开始日期', '结束日期']"
        v-bind="$attrs"
        :disabledDate="disabledDate"
        :ranges="ranges"
        :onCalendarChange="handleCalendarChange"
    />
  </div>
</template>

<script setup lang="tsx" name="SmartRangePicker">
import { RangePicker } from 'ant-design-vue'
import dayjs from 'dayjs'
import { inject, ref, computed } from 'vue'

const props = defineProps({
  rangeDay: {
    type: [String, Number],
    default: 7
  },
  maxRange: {
    type: [String, Number],
    default: 365
  },
})

const lang = inject('lang')

// 最大可选日期（限制不能早于 maxRange）
const maxSelectableDate = computed(() => {
  return dayjs().subtract(props.maxRange, 'day')
})

// 预设范围
const rangePresets = ref([
  { label: lang('今日'), value: [dayjs(), dayjs()] },
  { label: lang('最近一周'), value: [dayjs().subtract(6, 'day'), dayjs()] },
  { label: lang('本月'), value: [dayjs().startOf('month'), dayjs().endOf('month')] },
  { label: lang('上月'), value: [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')] }
])

// 快捷范围
const ranges = computed(() => ({
  [`${props.rangeDay}天`]: [dayjs().subtract(props.rangeDay - 1, 'day'), dayjs()]
}))

// 临时保存用户正在选的“开始日期”
const tempStart = ref<any>(null)

// 禁用日期
const disabledDate = (current: any) => {
  if (!current) return false

  // 禁用未来
  if (current.isAfter(dayjs(), 'day')) return true

  // 禁用超过 maxRange 之前的日期
  if (current.isBefore(maxSelectableDate.value, 'day')) return true

  // 如果用户已经选择了开始日期，则限制范围
  if (tempStart.value) {
    const tooLate = current.isAfter(dayjs(tempStart.value).add(props.rangeDay - 1, 'day'), 'day')
    const tooEarly = current.isBefore(dayjs(tempStart.value).subtract(props.rangeDay - 1, 'day'), 'day')
    return tooLate || tooEarly
  }

  return false
}

// 处理选择中的状态
const handleCalendarChange = (dates: any) => {
  if (dates && dates[0] && !dates[1]) {
    // 选了开始日期
    tempStart.value = dates[0]
  } else {
    // 选完整范围后清空，避免下次打开时还被限制
    tempStart.value = null
  }
}
</script>



<style lang="less">
.smart_popupClassName {
  .ant-picker-panel-layout {
    position: relative;
    padding-bottom: 42px;
    .ant-picker-presets {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 560px;
      right: 0;
      height: 42px;
      display: flex;
      ul {
        display: flex;
        border-width: 0;
        width: 560px;
        margin: 0;
        padding: 0;
        border-top: 1px solid #f5f5f5;
        align-items: center;
        li {
          border: 1px solid red;
          color: red;
          margin-top: 0px !important;
          background-color: #ffe3e3;
          margin-left: 8px;
          line-height: 16px;
          font-size: 12px;
          height: 20px;
          display: block;
        }
      }
    }
  }
}
</style>
